import styled from "styled-components";
import { Paragraph2, WrapperContainer } from "../../components";
import { PagesWrapper } from "../../components/PageSelector/styled";
import { colors } from "../../consts";

export const PageSelectorWrapper = styled(WrapperContainer)`
  width: 100%;

  align-items: center;

  ${PagesWrapper} {
    margin-top: 8px;
  }
`;

export const CertificatesButtonText = styled(Paragraph2)`
  ${(props) => props?.disabled && `color: ${colors.RAISIN_50};`}
`;
